// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__1r3Hh","tab":"TabNav_tab__nty2y","link":"TabNav_link__3wRpt","selectedLink":"TabNav_selectedLink__3brg0","disabled":"TabNav_disabled__3KTSl"};